export const GET_PAYMENT_IPG = "GET_PAYMENT_IPG"
export const GET_PAYMENT_IPG_PUBLIC = "GET_PAYMENT_IPG_PUBLIC"
export const GET_PAYMENT_IPG_SUCCESS = "GET_PAYMENT_IPG_SUCCESS"
export const GET_PAYMENT_IPG_FAIL = "GET_PAYMENT_IPG_FAIL"



export const PAYMENT_MELLI_RESET = "PAYMENT_MELLI_RESET"